module.exports = __webpack_public_path__ + "01_short_grey.61c694c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_short_grey.png
// module id = AhYJ
// module chunks = 0